
export enum EventType {
	LOAD = 1,
	TOGGLE_MODULE = 7,
	OPEN = 8,
	CLOSE = 9,
	FIRST_OPEN = 10,

	KB_HOME_VIEW = 11,
	CONTACT_VIEW = 12,
	ARTICLE_VIEW = 20,
	ARTICLE_NOT_FOUND = 21,
	ARTICLE_VOTE = 22,
	ARTICLE_UNVOTE = 23,
	ARTICLE_HELPFUL = 24,
	ARTICLE_UNHELPFUL = 25,

	SEARCH = 30,
	SEARCH_IGNORED = 31,
	SEARCH_NO_RESULT = 32,
	SEARCH_RESULT_CLICK = 33,

	CATEGORY_VIEW = 40,
	SELECT_CATEGORY = 41,

	SUBMIT_TICKET_ATTEMPT = 50,
	SUBMIT_TICKET_VALIDATION_ERROR = 51,
	SUBMIT_TICKET_SUCCESS = 52,
	SUBMIT_TICKET_FAIL = 53,
	SUBMIT_TICKET_CANCEL = 54,
	SUBMIT_TICKET_SELECT_SUGGESTED_ARTICLE = 55,

	CHAT_VIEW = 59,
	CHAT_STARTED = 60,
	CHAT_STARTED_SUCCESS = 61,
	CHAT_STARTED_FAIL = 62,
	UPDATE_EMAIL = 63,
	UPDATE_EMAIL_SUCCESS = 64,
	UPDATE_EMAIL_FAIL = 65,
	SUBSCRIBE_USER_TIMELINE = 66,
	SUBSCRIBE_USER_TIMELINE_SUCCESS = 67,
	SUBSCRIBE_USER_TIMELINE_FAIL = 68,
	SEND_CHAT_MESSAGE = 69,
	SEND_CHAT_MESSAGE_SUCCESS = 70,
	SEND_CHAT_MESSAGE_FAIL = 71,
	RECEIVE_CHAT_MESSAGE = 72,
	PUBSUB_EVENT = 73,
	CHAT_UNLOAD = 74,
	CHAT_HIDDEN = 75,
	CHAT_VISIBLE = 76,
	CHAT_TIMELINE_UPDATED = 77,
	CHAT_ONLINE = 78,
	SUBMIT_EMAIL_FORM = 79,
}
